'use client';

import React from 'react';

import { useRouter } from 'next/navigation';

import { Button } from '@repo/ui/button';
import Icon from '@repo/ui/icon';

import { useTranslation } from 'hooks/use-translation';

import { styles } from '.';

type TProps = {
  lang: string;
};

const ReturnButton = (props: TProps) => {
  const { lang } = props;

  const { t } = useTranslation(lang);

  const router = useRouter();

  return (
    <div onClick={() => router.back()}>
      <Button className={styles.button}>
        <Icon accessor="arrow-left" className={styles.icon} size="14px" />
        <p>{t('label.custom.return')}</p>
      </Button>
    </div>
  );
};

export default ReturnButton;
